import { render, staticRenderFns } from "./NewCandidate.vue?vue&type=template&id=e875a55e&"
import script from "./NewCandidate.vue?vue&type=script&lang=js&"
export * from "./NewCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports